import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

import { editorModules } from "../../utils/editorConfig";

import "assets/styles/editorQuill.scss";

const EditorQuill = props => {
  const {
    readOnly,
    placeholder,
    value,
    onChange,
    customStyle,
    customClassName,
    editorModulesCustom = null,
  } = props;

  const [content, setContent] = useState("");

  useEffect(() => {
    setContent(value);
  }, [value]);

  return (
    <>
      <ReactQuill
        placeholder={placeholder}
        readOnly={readOnly}
        theme={"snow"}
        defaultValue={""}
        onChange={val => {
          setContent(val);
          onChange && onChange(val);
        }}
        modules={editorModulesCustom ? editorModulesCustom() : editorModules()}
        value={content}
        preserveWhitespace={false}
        className={`${readOnly && "hiddenToolbar"} ${customClassName}`}
        style={{ ...customStyle }}
      />
    </>
  );
};

export default EditorQuill;
